/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "admin": {
                        "nested": {
                          "accountvalidation": {
                            "nested": {
                              "AccountValidationDecision": {
                                "values": {
                                  "DECISION_UNSPECIFIED": 0,
                                  "DECISION_YES": 1,
                                  "DECISION_NO": 2,
                                  "DECISION_UNSURE": 3
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.admin?.nested?.accountvalidation?.nested?.AccountValidationDecision) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AccountValidationDecision @ squareup/cash/gambit/api/v1/admin/accountvalidation/common.proto at 7:1
 */
export const AccountValidationDecision = $root.lookupEnum('squareup.cash.gambit.api.v1.admin.accountvalidation.AccountValidationDecision').values;